export default __webpack_public_path__ + "static/1159-449de9f59f5dc3621e6beea9468228c9.gif";